module.exports = __webpack_public_path__ + "static/img/pc.a347724.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/北京中加学校/pc.svg
// module id = Ri8l
// module chunks = 16